import { EDealType, TRecommendation } from '../types/recommendation';

export function prepareCplExtra(offer: TRecommendation) {
  if (offer.dealType !== EDealType.Sale) {
    return undefined;
  }

  const siteBlockId = offer.calltracking?.comagicId;
  const isFromDeveloper = Boolean(offer.author?.fromDeveloper) && !!offer.calltracking?.newbuildingId;
  const isFromLeadFactory = Boolean(offer.author?.isFromLeadFactory);

  return {
    cplDynamicCalltracking: siteBlockId ? 1 : 0,
    cplCalltracking: isFromDeveloper && !isFromLeadFactory ? 1 : 0,
  };
}
